import { Request } from '../main'
import Link from 'next/link'
import { Image } from 'react-bootstrap'
import params from '../data/params' 

const request = new Request(process.env.apiDomain)

function RelatedContent(props) {
    const { data: articles } = request.content.swrArticles({ section: props.center, category: props.category.slug, type: props.type, except_id: props.except, sort:"RANDOM", limit: 3 })
    const section = props.center == "education-center" ? 'education' : 'a';

    return (
        <>
        { articles && articles.length > 0 ?
        <div className="relatecontent">
            <p className="relatecontent__title mb-4"><strong>Related Content</strong></p>
                { 

                    articles.map((data,idx) => {

                        const theObject = data.data ? JSON.parse(data.data) : '';
                        const url = props.category.slug == 'books' ? (theObject ? theObject.media :  '/'+section+'/'+data.slug) : '/'+section+'/'+data.slug

                        return (
                            <div key={idx} className="mb-2">
                                {/*<Link href="/a/[slug]" as={`/a/${data.slug}`} replace> */}
                                <Link href={url} Passhref>
                                    <a><Image title={data.title} src={data.theThumbnail ? data.theThumbnail : params.noimage} className="img-fluid" width={props.category.slug != 'books' ? 300 : ''}/></a>
                                </Link>
                            </div>
                        )
                    }) 

                }
        </div>
        : null }
        </>
    )
}

export default RelatedContent
